<script lang="ts">
    import {fly} from 'svelte/transition'

    export let savedWordsCount: string
</script>

<div id="word-count-mobile">
    {#key savedWordsCount}
        <div id="word-count-mobile-count" in:fly|global={{ y: 10, duration: 700 }}>
            {savedWordsCount}
        </div>
    {/key}
    <div id="word-count-mobile-txt">
        {savedWordsCount === '1' ? 'word' : 'words'}<br>saved
    </div>
</div>

<style>
    #word-count-mobile {
        display: flex;
    }

    #word-count-mobile-count {
        margin-right: .3rem;
        font-size: 1.15rem;
        font-weight: var(--font-bold);
        line-height: 1.05;
    }

    #word-count-mobile-txt {
        font-size: .77rem;
        line-height: .8;
    }
</style>